/**
 * Handle scroll to section
 */

const handleScroolToSection = () => {
	$('.js-scroll').on('click', function() {
		const $this = $(this);
		const headerHeight = $('.header').outerHeight();
		const target = $this.attr('href');

		$('html, body').animate({
			scrollTop: $(target).offset().top - headerHeight
		}, 500)

		event.preventDefault();
	})
}

handleScroolToSection();
